var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5ZM8.03015 5.46248C8.00896 4.91142 8.44996 4.45312 9.00143 4.45312C9.5529 4.45312 9.99391 4.91142 9.97271 5.46248L9.78813 10.2618C9.77187 10.6845 9.42446 11.0188 9.00143 11.0188C8.57841 11.0188 8.231 10.6845 8.21474 10.2618L8.03015 5.46248ZM8.24357 12.7871C8.24357 12.3687 8.58275 12.0295 9.00115 12.0295C9.41955 12.0295 9.75873 12.3687 9.75873 12.7871C9.75873 13.2054 9.41955 13.5446 9.00115 13.5446C8.58275 13.5446 8.24357 13.2054 8.24357 12.7871Z",
    fill: "#FFC55E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/Alert.e91b8fa41d0f17f64ac59cce5921d48d.svg";
export { ForwardRef as ReactComponent };